var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutodialIconDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 1.66663L1.41121 10.5732C1.12054 10.922 0.975199 11.0964 0.972978 11.2437C0.971048 11.3717 1.02811 11.4935 1.12771 11.574C1.24229 11.6666 1.46931 11.6666 1.92336 11.6666H8L7.16666 18.3333L14.5888 9.42675C14.8795 9.07794 15.0248 8.90354 15.027 8.75624C15.0289 8.62819 14.9719 8.50637 14.8723 8.42588C14.7577 8.33329 14.5307 8.33329 14.0766 8.33329H8L8.83333 1.66663Z",
    stroke: "#C6CCC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutodialIconDisabled);
export default __webpack_public_path__ + "static/media/autodial-icon-disabled.d8330fe375cef3a161b3e457a0a18dac.svg";
export { ForwardRef as ReactComponent };